import { render, staticRenderFns } from "./allReviewSheet.vue?vue&type=template&id=9826f330&scoped=true&"
import script from "./allReviewSheet.vue?vue&type=script&lang=js&"
export * from "./allReviewSheet.vue?vue&type=script&lang=js&"
import style0 from "./allReviewSheet.vue?vue&type=style&index=0&id=9826f330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9826f330",
  null
  
)

export default component.exports